import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Logo } from '../../components/Logo/Logo';
import './Unsubscribe.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3010/api';

export const Unsubscribe: React.FC = () => {
  const { token, code } = useParams<{ token?: string; code?: string }>();
  const [status, setStatus] = useState<'loading' | 'ok' | 'err'>('loading');
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (!token && !code) {
      setStatus('err');
      setMessage('Link inválido.');
      return;
    }

    let cancelled = false;
    (async () => {
      try {
        const apiPath = code
          ? `/u/${encodeURIComponent(code)}`
          : `/unsubscribe/${encodeURIComponent(token!)}`;
        const res = await fetch(`${API_URL}${apiPath}`);
        const data = await res.json().catch(() => ({}));
        if (cancelled) return;
        if (!res.ok) {
          setStatus('err');
          setMessage(data.message || 'Não foi possível concluir o descadastro.');
          return;
        }
        setStatus('ok');
        setMessage(data.message || 'Descadastro confirmado.');
      } catch {
        if (!cancelled) {
          setStatus('err');
          setMessage('Erro de conexão. Tente novamente mais tarde.');
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [token, code]);

  return (
    <div className="unsubscribe-page">
      <header className="unsubscribe-header">
        <Logo />
      </header>
      <main className="unsubscribe-card">
        {status === 'loading' && <p className="unsubscribe-text">Processando seu pedido…</p>}
        {status === 'ok' && (
          <>
            <h1 className="unsubscribe-title">Tudo certo</h1>
            <p className="unsubscribe-text">{message}</p>
          </>
        )}
        {status === 'err' && (
          <>
            <h1 className="unsubscribe-title unsubscribe-title--err">Não foi possível concluir</h1>
            <p className="unsubscribe-text">{message}</p>
          </>
        )}
      </main>
    </div>
  );
};
